export function add(item) {
  return (prevSet) => new Set([...Array.from(prevSet), item])
}

export function remove(item) {
  return (prevSet) => new Set(Array.from(prevSet).filter((i) => i !== item))
}

export function toggle(item) {
  return (prevSet) =>
    prevSet.has(item) ? new Set(Array.from(prevSet).filter((i) => i !== item)) : new Set([...Array.from(prevSet), item])
}
export function has(item) {
  return (prevSet) => prevSet.has(item)
}
